<template>
  <span :class="{'gj-select-input': currentOption.moreShow}">
    <template v-if="object">
      <gj-input
          v-bind="$attrs"
          :placeholder="placeholder[1]"
          :style="{width: inputWidth}"
          v-model="value[prop.value]"
          :disabled="inputDisabled"
          :readonly="inputReadonly"
          @blur="$emit('blur', value)"
          @input="$emit('input', value)"
          :class="{'gj-select-input-active': value.popover}"
          isEnter
          :matching.sync="matching.type"
          @matchingChange="matchingChange"
          :clearable="inputClearable">
        <template #prepend>
          <gj-select
              v-model="value[prop.key]"
              :placeholder="placeholder[0]"
              :disabled="selectDisabled"
              :options="options"
              :width="width[0]"
              :clearable="false"
              @input="$emit('input', value)"
              @change="changeSelect"
              @input-option="$emit('input-option', $event)"
          ></gj-select>
          <!-- 操作符 -->
          <gj-select
              class="conditional-operation"
              :filterable="false"
              v-if="currentOption.conditionalOperation"
              v-model="value[prop.symbol]"
              :disabled="selectDisabled"
              :options="optionsSymbol"
              :width="width[2] || '70px'"
              :clearable="false"
          ></gj-select>
        </template>
        <template #prefix>
          <template v-if="$slots.prefix">
            <slot name="prefix"></slot>
          </template>
        </template>
        <template #suffix>
            <template v-if="$slots.suffix">
              <slot name="suffix"></slot>
            </template>
            <!-- 批量查询 -->
            <el-popover
              v-else-if="currentOption.moreShow"
              v-model="value.popover"
              placement="bottom"
              width="345">
              <div slot="reference" :style="{width: popoverWidth}" class="input-more-content" :class="{'single-input-content':singeInput}" @click="elInputFocus">
                <el-tooltip class="item" effect="dark" content="多项搜索" placement="top">
                  <span class="input-more">
                    <i v-for="item in 3" :key="item"></i>
                  </span>
                </el-tooltip>
              </div>
              <gj-textarea ref="textarea" :rows="8" v-model="value[prop.more]" placeholder="一行一项，最多支持200行"></gj-textarea>
              <div class="more-opt">
                <gj-button @click="empty" size="mini">重置</gj-button>
                <div style="display: flex;">
                  <gj-button @click="changeVisible" plain size="mini">关闭</gj-button>
                  <gj-button @click="confirm" type="primary" size="mini">确认</gj-button>
                </div>
              </div>
            </el-popover>
        </template>
      </gj-input>
    </template>
    <template v-else>
      <gj-input
          v-bind="$attrs"
          :placeholder="placeholder[1]"
          :style="{width: inputWidth}"
          :value="dnyValue"
          :matching.sync="matching.type"
          @matchingChange="matchingChange"
          @input="inputValue">
        <template #prepend>
          <gj-select
              :value="dnyKey"
              :placeholder="placeholder[0]"
              :options="options"
              :width="width[0]"
              :clearable="false"
              @input="inputKey"
          ></gj-select>
        </template>
    </gj-input>
    </template>
  </span>
</template>

<script>
  import GjInput from "./gj-input";
  import GjSelect from "../select/gj-select";
  import {addPx} from "../../utils/common";

  export default {
    name: "gj-select-input",
    components: {GjSelect, GjInput},
    props: {
      value: {
        type: Object,
        default() {
            return {key: null, value: null,more: null, popover: false, symbol: 'GREATER'}
        }
      },
      dnyKey: {
        type: String,
        default: null,
      },
      dnyValue: {
        type: String,
        default: null,
      },
      prop: {
        type: Object,
        default: () => ({key: 'key', value: 'value', more: 'more', symbol: "symbol"})
      },
      search: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: Array,
        default: () => ['请选择', '请输入']
      },
      inputClearable: {
        type: Boolean,
        default: true,
      },
      width: {
        type: Array,
        default: () => ['100px', '150px']
      },
      options: {
        type: Array,
        required: true
      },
      optionsSymbol: {
        type: Array,
        required: false,
        default: () => []
      },
      object: {
        type: Boolean,
        default: true,
      },
      inputDisabled: {
        type: Boolean,
        default: false
      },
      inputReadonly: {
        type: Boolean,
        default: false
      },
      selectDisabled: {
        type: Boolean,
        default: false
      },
      singeInput: {
        type: Boolean,
        default: false
      },
      matching: {
        type: Object,  // { type:like 模糊   exact 精确 }
        default: function(){
          return { type : null };
        }
      }
    },
    computed: {
      popoverWidth(){
        return (Number(this.width[1].replace('px', ''))+12+'px')||'210px'
      },
      inputWidth() {
        if (this.width[2]) {
          return addPx(addPx(this.width[0], this.width[1]), this.width[2])
        }
        return addPx(this.width[0], this.width[1]);
      },
      // 当前option
      currentOption() {
        for (const item of this.options) {
          if (item.id == this.value[this.prop.key]) { return item }
        }
        return {}
      },
    },
    methods: {
      iconfontChange(symbol) {
        this.value[this.prop.symbol] = symbol
      },
      changeSelect() {
        if (this.value[this.prop.value]) {
          this.value[this.prop.value] = ''
        }
        this.$emit('change', this.value)
        this.changeVisible()
      },
      // 批量弹窗获取焦点
      elInputFocus() {
        setTimeout(() => {
          this.$refs.textarea.$refs.elInput.focus()
        }, 100);
      },
      // 处理more
      changeVisible() {
        this.value.popover = false
      },
      // 清空
      empty() {
        this.value[this.prop.more] = null
        this.value[this.prop.value] = null
      },
      // 确认
      confirm() {
        if (this.value[this.prop.more]) {
          let moreArr = this.value[this.prop.more] .split('\n').filter(item => item != "")
          if (moreArr.length > 200) {
            this.$message.error("批量查询，请勿超过200行哦")
            return false
          }
          this.value[this.prop.value] = null
          this.value[this.prop.value] = moreArr.join(",")
        } else {
          this.value[this.prop.value] = null
        }
        this.$emit('confirm', this.value)
        this.changeVisible()
      },
      inputValue(value) {
        this.$emit('update:dnyValue', value);
      },
      inputKey(value) {
        this.$emit('update:dnyKey', value);
      },
      matchingChange(event) {
        this.$emit('matchingChange', event);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .img-icon {
    width: 9px;
    height: 10px;
  }
  /deep/.el-dropdown-menu__item {
    padding: 0;
  }
  .dropdown-cell {
    width: 64px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/.el-input__prefix {
    transition: none !important
  }
  /deep/.el-textarea__inner {
    border: 1px solid #D8DADD;
    border-radius: 2px;
    resize:none;
    padding: 6px;
  }
  .more-opt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    font-size: 12px;
    padding: 12px 0 0;
  }
  .more-opt .opt {
    color: #999;
    cursor: pointer;
    border: 1px solid #ddd;
    padding: 4px 6px;
    border-radius: 2px;
  }
  .more-opt .confirm {
    margin-left: 6px;
    color: #1F6EEF;
    border-color: #1F6EEF;
  }
  .gj-select-input {
    position: relative;
    .input-more-content {
      position: absolute;
      right: -4px;
      top: 0;
    }
  }
  .input-more-content {
    width: auto !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: -17px;
    cursor: pointer;
  }
  .single-input-content{
    width: 20px;
  }
  .input-more {
    width: 12px;
    height: 22px;
    padding: 4px 0;
    background: #f5f9ff;
    cursor: pointer;
    color: #62a6ff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    border-radius: 2px;
    border-left: 0;
  }
  .input-more i {
    width: 3px;
    height: 3px;
    background: #62a6ff;
    border-radius: 100%;
  }
  /deep/.el-icon-more {
    transform: rotate(90deg);
  }
  .el-icon-search {
    cursor: pointer;
  }



  /deep/ .el-input-group--prepend{
    display: flex;
    align-items: center;
    // 左边的下拉框
    .el-input-group__prepend{
      width: auto;
      min-width: auto;
      padding: 0;
      background: #fff;
      border-radius: 2px;
      border: none;
      .el-select {
        margin: 0;
        .el-input__inner{
            box-shadow: none;
            cursor: pointer;
            border-radius: 2px;
            border: 1px solid #D8DADD;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right-color: rgba($color: #000000, $alpha: 0);
        }
        &:hover{
          box-sizing: border-box;
          .el-input__inner{
            border: 1px solid #1F6EEF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            border: 1px solid #1F6EEF;
          }
        }
      }
    }
    // 右边的输入框
    .el-input__inner{
      border-radius: 2px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      &:hover{
        border-color:#1F6EEF;
      }
    }
    .conditional-operation {
      .el-input__inner {
        border-radius: 0 !important;
      }
    }
    &.is-disabled{
      .el-input__inner:hover{
          border-color:#D8DADD;
        }
    }
  }
</style>
